import { Link } from "react-router-dom";
import { getSpecials } from "@/utils/content";
import { getDramasByIds } from "@/utils/content";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SpecialSection() {
  const specials = getSpecials();

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
      <SectionHeading
        title="相关专题推介"
        subtitle="按主题精选的影视合集，帮你发现更多好内容"
        icon="ri-bookmark-3-line"
        moreTo="/special"
      />

      <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-2">
        {specials.slice(0, 4).map((special) => {
          const items = getDramasByIds(special.dramaIds).slice(0, 3);
          return (
            <Link
              key={special.id}
              to={`/special/${special.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 md:flex-row"
            >
              <div className="h-40 w-full shrink-0 overflow-hidden bg-background-200 md:h-auto md:w-48">
                <img
                  src={special.cover}
                  alt={`${special.title} 专题图`}
                  title={`${special.title} 影视推荐专题`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {special.theme}合集
                </span>
                <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 md:text-lg">
                  {special.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {special.intro}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  {items.map((drama) => (
                    <span
                      key={drama.id}
                      className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
                    >
                      {drama.title}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}